<template>
    <div class="flex items-center gap-x-2 justify-between">
        <div>
            <span>{{ asset.name }}</span>

            <span v-if="asset.external_source"
                  class="mdi mdi-link-variant text-gray-400 text-xs mb-1">
                {{ asset.external_source }}
            </span>
        </div>

        <div>
            <span v-if="asset.current_mandate_type"
                  class="rounded font-medium text-xs px-1 py-0 leading-tight"
                  :class="asset.current_mandate_type === 'managed' ? 'bg-indigo-100 text-indigo-600': 'bg-gray-100 text-gray-600'">
                {{ asset.current_mandate_type | titlecase }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        asset: {
            type: Object,
            required: true,
        },
    },
};
</script>
